// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   EditingKeyframeView Styles
   
   Design System: Uses CSS variables from colors.css
   - Flat surfaces with borders (no gradients)
   - Semantic colors only
   - Functional animations only
   ====================== */

/* ======================
   BASE LAYOUT
   ====================== */

.editing-keyframe-canvas {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  /* Override '.canvas-placeholder' defaults so preview is sized consistently */
  padding: 0 !important;
  gap: 0 !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  overflow: hidden;
}

.editing-keyframe-version-preview-banner {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px dashed var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
  pointer-events: none;
  z-index: 11;
  white-space: nowrap;
}

.editing-keyframe-full-canvas {
  position: relative;
  flex: 1 1;
  width: 100%;
  min-height: 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  overflow: hidden;
}

/* ======================
   CANVAS & MEDIA
   ====================== */

.editing-keyframe-full-image {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  margin: 0;
  padding: 0;
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
  object-fit: contain;
}

.editing-keyframe-media-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  max-height: 100%;
  min-width: 0;
  min-height: 0;
  border-radius: 2px;
  overflow: visible;
  border: 1px solid var(--color-border-input);
}

.editing-keyframe-canvas-overlay {
  position: absolute;
  top: 0;
  left: 0;
  transform: none;
  cursor: inherit;
}

/* ======================
   SNAP GUIDES
   ====================== */

.editing-keyframe-snap-guides {
  position: absolute;
  pointer-events: none;
  z-index: 170;
}

.editing-keyframe-snap-line {
  position: absolute;
  background: var(--color-text-secondary);
  box-shadow: 0 0 0 1px var(--color-bg-canvas-surface);
}

.editing-keyframe-snap-line-vertical {
  top: 0;
  bottom: 0;
  width: 1px;
}

.editing-keyframe-snap-line-horizontal {
  left: 0;
  right: 0;
  height: 1px;
}

/* ======================
   OVERLAYS
   ====================== */

.editing-keyframe-generating-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--color-bg-canvas-surface);
  opacity: 0.7;
  z-index: 200;
  border-radius: 2px;
}

/* ======================
   TEXT LAYERS
   ====================== */

.editing-keyframe-text-layer {
  position: absolute;
  cursor: move;
  padding: 4px 8px;
  border: 1px solid transparent;
  border-radius: 2px;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.editing-keyframe-text-layer.editing {
  border-color: var(--color-text-secondary);
  background: var(--color-bg-canvas-surface);
  cursor: text;
  -webkit-user-select: text;
          user-select: text;
}

/* ======================
   ERROR STATES
   ====================== */

.editing-keyframe-error {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--color-bg-user-bubble);
  border: 1px solid var(--color-border-input);
  color: var(--color-text-primary);
  padding: 8px 14px;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 500;
  z-index: 50;
}

/* ======================
   MAGIC SELECT - LOADING
   ====================== */

.magic-select-ripple-container {
  position: absolute;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 200;
}

/* Simple spinner instead of decorative ripples */
.magic-select-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid var(--color-border-input);
  border-top-color: var(--color-text-secondary);
  border-radius: 50%;
  animation: magicSelectSpin 0.8s linear infinite;
}

@keyframes magicSelectSpin {
  to {
    transform: rotate(360deg);
  }
}

/* ======================
   MAGIC SELECT - MASK
   ====================== */

.magic-select-mask-container {
  position: absolute;
  pointer-events: none;
  z-index: 100;
  overflow: hidden;
  margin: 0;
  padding: 0;
  border: none;
  box-sizing: border-box;
}

.magic-select-mask-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  pointer-events: none;
  opacity: 0.5;
  filter:
    drop-shadow(0 0 1px #ffffff)
    drop-shadow(0 0 3px rgba(0, 0, 0, 0.95))
    drop-shadow(0 0 6px rgba(255, 255, 255, 0.8));
}

.magic-select-mask-glare {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.42;
  background:
    repeating-linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.92) 0,
      rgba(255, 255, 255, 0.92) 5px,
      rgba(0, 0, 0, 0.72) 5px,
      rgba(0, 0, 0, 0.72) 10px
    ),
    rgba(28, 213, 255, 0.24);
}

/* Static dashed border instead of animated marching ants */
.magic-select-mask-border {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

.magic-select-mask-border img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  opacity: 0.85;
  filter:
    brightness(0)
    invert(1)
    drop-shadow(0 0 1px #000000)
    drop-shadow(0 0 3px rgba(0, 0, 0, 0.95));
}

/* ======================
   MAGIC SELECT - ACTIONS
   ====================== */

.magic-select-actions {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  gap: 2px;
  z-index: 300;
  padding: 4px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
}

.magic-select-action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: none;
  border-radius: 3px;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  white-space: nowrap;
}

.magic-select-action-btn:hover {
  background: var(--color-bg-input);
  color: var(--color-text-primary);
}

.magic-select-action-btn svg {
  flex-shrink: 0;
  opacity: 0.7;
}

/* Uniform hover state - no per-action colors */
.magic-select-action-duplicate:hover,
.magic-select-action-edit:hover,
.magic-select-action-cut:hover {
  background: var(--color-bg-input);
  color: var(--color-text-primary);
}

.magic-select-action-delete:hover {
  background: rgba(220, 38, 38, 0.1);
  color: #dc2626;
}

.magic-select-action-cancel {
  padding: 8px;
  background: transparent;
  margin-left: 2px;
}

.magic-select-action-cancel:hover {
  background: var(--color-bg-input);
}

.magic-select-action-cancel span {
  display: none;
}

/* ======================
   MAGIC SELECT - EDIT INPUT
   ====================== */

.magic-select-edit-container {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  z-index: 500;
  max-width: min(760px, calc(100vw - 48px));
  padding: 6px 10px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 3px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.4);
}

.magic-select-edit-input {
  width: min(320px, 42vw);
  min-width: 180px;
  padding: 8px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 2px;
  background: var(--color-bg-input);
  font-size: 12px;
  font-family: inherit;
  color: var(--color-text-primary);
  transition: border-color 0.15s ease;
}

.magic-select-edit-input:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.magic-select-edit-input::placeholder {
  color: var(--color-text-secondary);
}

.magic-select-edit-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.magic-select-edit-submit,
.magic-select-edit-cancel {
  padding: 8px 14px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.magic-select-edit-enhance {
  padding: 8px 12px;
  border-radius: 3px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.magic-select-edit-enhance:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.magic-select-edit-enhance:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.magic-select-edit-submit {
  border: 1px solid var(--color-text-primary);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
}

.magic-select-edit-submit:hover:not(:disabled) {
  opacity: 0.9;
}

.magic-select-edit-submit:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.magic-select-edit-cancel {
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
}

.magic-select-edit-cancel:hover:not(:disabled) {
  background: var(--color-bg-input);
  color: var(--color-text-primary);
}

.magic-select-edit-cancel:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ======================
   MAGIC SELECT - EDIT INPUT ENHANCING STATE
   ====================== */

.magic-select-edit-input-wrapper {
  position: relative;
}

.magic-select-edit-input.enhancing {
  opacity: 0.6;
  pointer-events: none;
}

.magic-select-edit-enhancing-overlay {
  position: absolute;
  inset: 0;
  border-radius: 2px;
  overflow: hidden;
  pointer-events: none;
  z-index: 1;
}

.magic-select-edit-enhancing-shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.08) 20%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.08) 80%,
    transparent 100%
  );
  background-size: 200% 100%;
  animation: magicSelectEnhanceShimmer 1.5s ease-in-out infinite;
}

@keyframes magicSelectEnhanceShimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* ======================
   MAGIC SELECT - DUPLICATED LAYER
   ====================== */

.magic-select-duplicated-layer {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  background: var(--color-bg-sidebar);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  z-index: 300;
  pointer-events: none;
}

.magic-select-duplicated-layer img {
  max-width: 200px;
  max-height: 150px;
  object-fit: contain;
  border-radius: 2px;
  border: 1px solid var(--color-border-input);
}

.magic-select-duplicated-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-secondary);
}

/* ======================
   MAGIC SELECT - CUTOUT
   ====================== */

.magic-select-cutout-container {
  position: absolute;
  overflow: hidden;
}

.magic-select-cutout-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    linear-gradient(45deg, var(--color-border-input) 25%, transparent 25%),
    linear-gradient(-45deg, var(--color-border-input) 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, var(--color-border-input) 75%),
    linear-gradient(-45deg, transparent 75%, var(--color-border-input) 75%);
  background-size: 16px 16px;
  background-position: 0 0, 0 8px, 8px -8px, -8px 0px;
  border-radius: 2px;
}

.magic-select-cutout-image {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  object-fit: fill;
  border-radius: 2px;
}

/* ======================
   LASSO SELECTION
   ====================== */

.editing-keyframe-lasso-overlay path {
  animation: lassoDash 0.5s linear infinite;
  stroke: var(--color-text-primary);
  fill: var(--color-border-user-bubble);
  filter: drop-shadow(0 0 2px var(--color-bg-canvas-surface));
}

@keyframes lassoDash {
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 20;
  }
}

/* ======================
   WORLD EXPLORER OVERLAY
   ====================== */

.world-explorer-overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  background: var(--color-bg-canvas-surface, #0a0a0a);
  border-radius: 6px;
  overflow: hidden;
}

.world-explorer-canvas {
  flex: 1 1;
  min-height: 0;
  position: relative;
}

.world-explorer-canvas canvas {
  display: block;
  width: 100%;
  height: 100%;
  cursor: crosshair;
}

.world-explorer-loading {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: var(--color-bg-canvas-surface, #0a0a0a);
  color: var(--color-text-secondary);
  font-size: 14px;
  z-index: 5;
}

.world-explorer-error {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: var(--color-bg-canvas-surface, #0a0a0a);
  color: var(--color-error, #ef4444);
  font-size: 14px;
  z-index: 5;
}

.world-explorer-error-close {
  padding: 8px 14px;
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  transition: background 0.15s ease, color 0.15s ease;
}

.world-explorer-error-close:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

/* Top chrome: tight to viewport top; hint centered, actions top-right (same row) */
.world-explorer-chrome {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 15;
  padding: 6px 12px;
  box-sizing: border-box;
  pointer-events: none;
}

.world-explorer-instructions {
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  box-shadow: var(--color-shadow-user-bubble);
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  text-align: center;
  max-width: min(420px, calc(100% - 200px));
  pointer-events: none;
}

.world-explorer-instructions svg {
  flex-shrink: 0;
  color: var(--color-text-secondary);
  opacity: 0.85;
}

.world-explorer-controls {
  position: absolute;
  top: 6px;
  right: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  pointer-events: auto;
}

.world-explorer-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  box-shadow: none;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;
}

.world-explorer-btn:hover:not(:disabled) {
  opacity: 1;
}

.world-explorer-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.world-explorer-btn-capture {
  border-color: var(--color-accent-base);
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
}

.world-explorer-btn-capture:hover:not(:disabled) {
  background: var(--color-accent-strong);
  border-color: var(--color-accent-strong);
}

.world-explorer-btn-cancel {
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
}

.world-explorer-btn-cancel:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
  border-color: var(--color-border-user-bubble);
}

.world-explorer-spinner {
  animation: worldExplorerSpin 1s linear infinite;
}

@keyframes worldExplorerSpin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/editor/canvas-modes/EditingKeyframeView.css"],"names":[],"mappings":"AAAA;;;;;;;2BAO2B;;AAE3B;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,6EAA6E;EAC7E,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;EAC5C,0CAA0C;EAC1C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAW;EACX,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;2BAE2B;;AAE3B;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;EACf,eAAe;AACjB;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,oDAAoD;AACtD;;AAEA;EACE,MAAM;EACN,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,uCAAuC;EACvC,2CAA2C;EAC3C,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ;;;iDAG+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,aAAa;EACb;;;;;;;;4BAQ0B;AAC5B;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb;;;;4CAI0C;AAC5C;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,+CAA+C;AAC/C;;;EAGE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yCAAyC;EACzC,iBAAiB;EACjB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;;;GAOC;EACD,0BAA0B;EAC1B,8DAA8D;AAChE;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;2EAIyE;EACzE,0BAA0B;EAC1B,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;2BAE2B;;AAE3B;EACE,yCAAyC;EACzC,iCAAiC;EACjC,qCAAqC;EACrC,2DAA2D;AAC7D;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mDAAmD;EACnD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mDAAmD;EACnD,kCAAkC;EAClC,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mDAAmD;EACnD,kCAAkC;EAClC,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA,mFAAmF;AACnF;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,2CAA2C;EAC3C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gGAAgG;AAClG;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* ======================\n   EditingKeyframeView Styles\n   \n   Design System: Uses CSS variables from colors.css\n   - Flat surfaces with borders (no gradients)\n   - Semantic colors only\n   - Functional animations only\n   ====================== */\n\n/* ======================\n   BASE LAYOUT\n   ====================== */\n\n.editing-keyframe-canvas {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  /* Override '.canvas-placeholder' defaults so preview is sized consistently */\n  padding: 0 !important;\n  gap: 0 !important;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  overflow: hidden;\n}\n\n.editing-keyframe-version-preview-banner {\n  position: absolute;\n  top: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 6px 14px;\n  border-radius: 6px;\n  border: 1px dashed var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  pointer-events: none;\n  z-index: 11;\n  white-space: nowrap;\n}\n\n.editing-keyframe-full-canvas {\n  position: relative;\n  flex: 1 1 0;\n  width: 100%;\n  min-height: 0;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n/* ======================\n   CANVAS & MEDIA\n   ====================== */\n\n.editing-keyframe-full-image {\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  margin: 0;\n  padding: 0;\n  user-select: none;\n  -webkit-user-drag: none;\n  object-fit: contain;\n}\n\n.editing-keyframe-media-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 100%;\n  max-height: 100%;\n  min-width: 0;\n  min-height: 0;\n  border-radius: 2px;\n  overflow: visible;\n  border: 1px solid var(--color-border-input);\n}\n\n.editing-keyframe-canvas-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: none;\n  cursor: inherit;\n}\n\n/* ======================\n   SNAP GUIDES\n   ====================== */\n\n.editing-keyframe-snap-guides {\n  position: absolute;\n  pointer-events: none;\n  z-index: 170;\n}\n\n.editing-keyframe-snap-line {\n  position: absolute;\n  background: var(--color-text-secondary);\n  box-shadow: 0 0 0 1px var(--color-bg-canvas-surface);\n}\n\n.editing-keyframe-snap-line-vertical {\n  top: 0;\n  bottom: 0;\n  width: 1px;\n}\n\n.editing-keyframe-snap-line-horizontal {\n  left: 0;\n  right: 0;\n  height: 1px;\n}\n\n/* ======================\n   OVERLAYS\n   ====================== */\n\n.editing-keyframe-generating-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--color-bg-canvas-surface);\n  opacity: 0.7;\n  z-index: 200;\n  border-radius: 2px;\n}\n\n/* ======================\n   TEXT LAYERS\n   ====================== */\n\n.editing-keyframe-text-layer {\n  position: absolute;\n  cursor: move;\n  padding: 4px 8px;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  user-select: none;\n  white-space: nowrap;\n}\n\n.editing-keyframe-text-layer.editing {\n  border-color: var(--color-text-secondary);\n  background: var(--color-bg-canvas-surface);\n  cursor: text;\n  user-select: text;\n}\n\n/* ======================\n   ERROR STATES\n   ====================== */\n\n.editing-keyframe-error {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--color-bg-user-bubble);\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-primary);\n  padding: 8px 14px;\n  border-radius: 2px;\n  font-size: 12px;\n  font-weight: 500;\n  z-index: 50;\n}\n\n/* ======================\n   MAGIC SELECT - LOADING\n   ====================== */\n\n.magic-select-ripple-container {\n  position: absolute;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  z-index: 200;\n}\n\n/* Simple spinner instead of decorative ripples */\n.magic-select-spinner {\n  width: 24px;\n  height: 24px;\n  border: 2px solid var(--color-border-input);\n  border-top-color: var(--color-text-secondary);\n  border-radius: 50%;\n  animation: magicSelectSpin 0.8s linear infinite;\n}\n\n@keyframes magicSelectSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ======================\n   MAGIC SELECT - MASK\n   ====================== */\n\n.magic-select-mask-container {\n  position: absolute;\n  pointer-events: none;\n  z-index: 100;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n  border: none;\n  box-sizing: border-box;\n}\n\n.magic-select-mask-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  pointer-events: none;\n  opacity: 0.5;\n  filter:\n    drop-shadow(0 0 1px #ffffff)\n    drop-shadow(0 0 3px rgba(0, 0, 0, 0.95))\n    drop-shadow(0 0 6px rgba(255, 255, 255, 0.8));\n}\n\n.magic-select-mask-glare {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0.42;\n  background:\n    repeating-linear-gradient(\n      135deg,\n      rgba(255, 255, 255, 0.92) 0,\n      rgba(255, 255, 255, 0.92) 5px,\n      rgba(0, 0, 0, 0.72) 5px,\n      rgba(0, 0, 0, 0.72) 10px\n    ),\n    rgba(28, 213, 255, 0.24);\n}\n\n/* Static dashed border instead of animated marching ants */\n.magic-select-mask-border {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.magic-select-mask-border img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  opacity: 0.85;\n  filter:\n    brightness(0)\n    invert(1)\n    drop-shadow(0 0 1px #000000)\n    drop-shadow(0 0 3px rgba(0, 0, 0, 0.95));\n}\n\n/* ======================\n   MAGIC SELECT - ACTIONS\n   ====================== */\n\n.magic-select-actions {\n  position: absolute;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: row;\n  gap: 2px;\n  z-index: 300;\n  padding: 4px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n}\n\n.magic-select-action-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: none;\n  border-radius: 3px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  white-space: nowrap;\n}\n\n.magic-select-action-btn:hover {\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n}\n\n.magic-select-action-btn svg {\n  flex-shrink: 0;\n  opacity: 0.7;\n}\n\n/* Uniform hover state - no per-action colors */\n.magic-select-action-duplicate:hover,\n.magic-select-action-edit:hover,\n.magic-select-action-cut:hover {\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n}\n\n.magic-select-action-delete:hover {\n  background: rgba(220, 38, 38, 0.1);\n  color: #dc2626;\n}\n\n.magic-select-action-cancel {\n  padding: 8px;\n  background: transparent;\n  margin-left: 2px;\n}\n\n.magic-select-action-cancel:hover {\n  background: var(--color-bg-input);\n}\n\n.magic-select-action-cancel span {\n  display: none;\n}\n\n/* ======================\n   MAGIC SELECT - EDIT INPUT\n   ====================== */\n\n.magic-select-edit-container {\n  position: absolute;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  z-index: 500;\n  max-width: min(760px, calc(100vw - 48px));\n  padding: 6px 10px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 3px;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.4);\n}\n\n.magic-select-edit-input {\n  width: min(320px, 42vw);\n  min-width: 180px;\n  padding: 8px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 2px;\n  background: var(--color-bg-input);\n  font-size: 12px;\n  font-family: inherit;\n  color: var(--color-text-primary);\n  transition: border-color 0.15s ease;\n}\n\n.magic-select-edit-input:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.magic-select-edit-input::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.magic-select-edit-actions {\n  display: flex;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.magic-select-edit-submit,\n.magic-select-edit-cancel {\n  padding: 8px 14px;\n  border-radius: 3px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.magic-select-edit-enhance {\n  padding: 8px 12px;\n  border-radius: 3px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.magic-select-edit-enhance:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.magic-select-edit-enhance:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.magic-select-edit-submit {\n  border: 1px solid var(--color-text-primary);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n}\n\n.magic-select-edit-submit:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.magic-select-edit-submit:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.magic-select-edit-cancel {\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n}\n\n.magic-select-edit-cancel:hover:not(:disabled) {\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n}\n\n.magic-select-edit-cancel:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ======================\n   MAGIC SELECT - EDIT INPUT ENHANCING STATE\n   ====================== */\n\n.magic-select-edit-input-wrapper {\n  position: relative;\n}\n\n.magic-select-edit-input.enhancing {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.magic-select-edit-enhancing-overlay {\n  position: absolute;\n  inset: 0;\n  border-radius: 2px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.magic-select-edit-enhancing-shimmer {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(255, 255, 255, 0.08) 20%,\n    rgba(255, 255, 255, 0.15) 50%,\n    rgba(255, 255, 255, 0.08) 80%,\n    transparent 100%\n  );\n  background-size: 200% 100%;\n  animation: magicSelectEnhanceShimmer 1.5s ease-in-out infinite;\n}\n\n@keyframes magicSelectEnhanceShimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* ======================\n   MAGIC SELECT - DUPLICATED LAYER\n   ====================== */\n\n.magic-select-duplicated-layer {\n  position: absolute;\n  bottom: 80px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 20px;\n  background: var(--color-bg-sidebar);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  z-index: 300;\n  pointer-events: none;\n}\n\n.magic-select-duplicated-layer img {\n  max-width: 200px;\n  max-height: 150px;\n  object-fit: contain;\n  border-radius: 2px;\n  border: 1px solid var(--color-border-input);\n}\n\n.magic-select-duplicated-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n}\n\n/* ======================\n   MAGIC SELECT - CUTOUT\n   ====================== */\n\n.magic-select-cutout-container {\n  position: absolute;\n  overflow: hidden;\n}\n\n.magic-select-cutout-grid {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image:\n    linear-gradient(45deg, var(--color-border-input) 25%, transparent 25%),\n    linear-gradient(-45deg, var(--color-border-input) 25%, transparent 25%),\n    linear-gradient(45deg, transparent 75%, var(--color-border-input) 75%),\n    linear-gradient(-45deg, transparent 75%, var(--color-border-input) 75%);\n  background-size: 16px 16px;\n  background-position: 0 0, 0 8px, 8px -8px, -8px 0px;\n  border-radius: 2px;\n}\n\n.magic-select-cutout-image {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  object-fit: fill;\n  border-radius: 2px;\n}\n\n/* ======================\n   LASSO SELECTION\n   ====================== */\n\n.editing-keyframe-lasso-overlay path {\n  animation: lassoDash 0.5s linear infinite;\n  stroke: var(--color-text-primary);\n  fill: var(--color-border-user-bubble);\n  filter: drop-shadow(0 0 2px var(--color-bg-canvas-surface));\n}\n\n@keyframes lassoDash {\n  0% {\n    stroke-dashoffset: 0;\n  }\n  100% {\n    stroke-dashoffset: 20;\n  }\n}\n\n/* ======================\n   WORLD EXPLORER OVERLAY\n   ====================== */\n\n.world-explorer-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  background: var(--color-bg-canvas-surface, #0a0a0a);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.world-explorer-canvas {\n  flex: 1;\n  min-height: 0;\n  position: relative;\n}\n\n.world-explorer-canvas canvas {\n  display: block;\n  width: 100%;\n  height: 100%;\n  cursor: crosshair;\n}\n\n.world-explorer-loading {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  background: var(--color-bg-canvas-surface, #0a0a0a);\n  color: var(--color-text-secondary);\n  font-size: 14px;\n  z-index: 5;\n}\n\n.world-explorer-error {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  background: var(--color-bg-canvas-surface, #0a0a0a);\n  color: var(--color-error, #ef4444);\n  font-size: 14px;\n  z-index: 5;\n}\n\n.world-explorer-error-close {\n  padding: 8px 14px;\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.world-explorer-error-close:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n/* Top chrome: tight to viewport top; hint centered, actions top-right (same row) */\n.world-explorer-chrome {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 15;\n  padding: 6px 12px;\n  box-sizing: border-box;\n  pointer-events: none;\n}\n\n.world-explorer-instructions {\n  position: absolute;\n  top: 6px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  box-shadow: var(--color-shadow-user-bubble);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.35;\n  text-align: center;\n  max-width: min(420px, calc(100% - 200px));\n  pointer-events: none;\n}\n\n.world-explorer-instructions svg {\n  flex-shrink: 0;\n  color: var(--color-text-secondary);\n  opacity: 0.85;\n}\n\n.world-explorer-controls {\n  position: absolute;\n  top: 6px;\n  right: 12px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  pointer-events: auto;\n}\n\n.world-explorer-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  box-shadow: none;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;\n}\n\n.world-explorer-btn:hover:not(:disabled) {\n  opacity: 1;\n}\n\n.world-explorer-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.world-explorer-btn-capture {\n  border-color: var(--color-accent-base);\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n}\n\n.world-explorer-btn-capture:hover:not(:disabled) {\n  background: var(--color-accent-strong);\n  border-color: var(--color-accent-strong);\n}\n\n.world-explorer-btn-cancel {\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n}\n\n.world-explorer-btn-cancel:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n  border-color: var(--color-border-user-bubble);\n}\n\n.world-explorer-spinner {\n  animation: worldExplorerSpin 1s linear infinite;\n}\n\n@keyframes worldExplorerSpin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
